"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButtons = exports.StyledIconWrapper = exports.StyledModal = exports.StyledModalOverlay = void 0;
const app_1 = require("@obvio/app");
const framer_motion_1 = require("framer-motion");
exports.StyledModalOverlay = (0, framer_motion_1.motion)(app_1.styled.div `
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(0.625rem);
  display: 'flex';
  align-items: center;
  justify-content: center;
  // TODO: This is ridiculous
  z-index: ${(_, { $index = 0 }) => 100000000 + $index};
  ${(theme) => theme.modal.backdrop}
`);
exports.StyledModal = (0, framer_motion_1.motion)(app_1.styled.dialog `
  background: white;
  display: flex;
  flex-direction: column;
  padding: 0;
  overflow: hidden;
  border: none;
  box-shadow: 0.3125rem 0.3125rem 1.25rem rgba(0, 0, 0, 0.3);
  border-radius: ${(theme) => theme.radius.small};
  height: auto;
  > header,
  > section,
  > footer {
    padding: ${(theme) => theme.spacing.small};
  }
  > header {
    position: relative;
    display: flex;
    align-items: center;
    > h5 {
      flex: 1;
      margin: 0;
      font-size: 1.0625rem;
      line-height: 1rem;
    }
    + section,
    + footer {
      border-top: 0.0625rem solid ${(theme) => theme.stroke};
    }
  }
  > section {
    flex: 1;
    min-height: 8.125rem;
    overflow: overlay;
  }
  > footer {
    font-size: 0.874rem;
    color: rgb(143, 143, 143);
  }
  @media ${app_1.mobile} {
    max-width: 100vw !important;
    margin-top: ${(theme) => theme.spacing.medium};
    left: 0;
    right: 0;
    bottom: 0;
    position: absolute;
    max-height: calc(100% - ${(theme) => theme.spacing.medium});
    width: 100%;
  }
  @media ${app_1.notMobile} {
    max-height: calc(100vh - 2 * ${(theme) => theme.spacing.medium});
  }
  ${(theme) => theme.modal.css}
`);
exports.StyledIconWrapper = app_1.styled.div `
  cursor: pointer;
  > div {
    cursor: pointer;
    font-size: 2.5rem;
    font-weight: 300;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 1.5rem;
    width: 1.5rem;
  }
  transition: color 200ms;
  &:hover {
    color: rgba(0, 0, 0, 0.5);
  }
`;
exports.StyledButtons = app_1.styled.div `
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-end;
  button:not(:last-of-type) {
    margin-right: 0.625rem;
  }
`;
